import { useDispatch, useSelector } from "react-redux";
import Footer from "../../../Components/Footer";
import Header from "../../../Components/Header";
import PriceBar from "../../../Components/PriceBar";
import { useEffect, useMemo, useState } from "react";
import { getAllEarnCampaign } from "../../../Features/EarnCampaign/earnSlice";
import "./index.css";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import EarnModal from "./Modal";

function EarnCampaign() {
  const { allEarnCampaigns, isSuccess, isError, isLoading, error } =
    useSelector((state) => state?.earn);
  const isLoggedIn = useSelector((state) => state?.user?.isAuthenticated);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState({});

  useEffect(() => {
    dispatch(getAllEarnCampaign());
  }, []);

  const campaigns = useMemo(() => {
    if (!allEarnCampaigns?.data?.length) return [];
    // clone to avoid mutation
    return [...allEarnCampaigns.data]
      .filter((d) => d?.IsActive === true)
      .sort((a, b) => Number(b?.IsFeatured) - Number(a?.IsFeatured));
  }, [allEarnCampaigns?.data]);

  const handleAddEarn = (data) => {
    setShowModal(true);
    setSelectedCampaign(data);
  };

  return (
    <div>
      <Header />
      <PriceBar />

      <div className="container">
        <div className="mt-5 earn_banner">
          <div className="row">
            <div className="col-12 col-sm-6 content d-flex align-items-center">
              <div>
                <h3>Earn up to 15% (APR) annually on Crypto & Stablecoins</h3>
                <p>
                  Grow your wealth with top rates on USDT, ETH, SOL and other
                  assets.
                </p>
                {isLoggedIn ? (
                  ""
                ) : (
                  // <p className="earning">Total Earning: 0.00 LTK</p>
                  <Link href="/login" className="joinBtn">
                    Login
                  </Link>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 image d-flex justify-content-center ">
              <img
                src="/images/banner_earn.png"
                alt="Earn banner"
                width={300}
              />
            </div>
          </div>
        </div>
        <div className="row pt-3 pb-3 align-items-center">
          <div className="col-12 col-sm-6 pb-2 pb-md-0">
            <h1 className="txtColor text-center text-sm-start text-semibold">
              Earn Campaigns
            </h1>
          </div>
          <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end align-items-center gap-2">
            <Link to="/earn-history">View Earn History</Link>
          </div>
        </div>
        {isLoading ? (
          <div className="container mb-5">
            <span className="txtColor">Loading</span>
          </div>
        ) : (
          <div className="row pb-5">
            {campaigns?.length > 0 ? (
              campaigns?.map((c) => (
                <div className="col-12 col-sm-6 col-lg-3 p-2">
                  <div className="campaignBox">
                    <div className="d-flex justify-content-between header borderB align-items-center">
                      <h5 className="">{c?.Title}</h5>
                      <div className="d-flex justify-content-end tags">
                        {c?.IsFeatured && (
                          <span className="tag featured">{"Featured"}</span>
                        )}
                        {c?.IsOneTime && (
                          <span className="tag onetime">{"One-Time"}</span>
                        )}
                      </div>
                    </div>
                    <div className="borderB">
                      <p className="txtColor pb-0 mb-0">{c?.Description}</p>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <p className="txtColor">Lock:</p>
                      </div>
                      <div className="col-8 d-flex align-items-center gap-2">
                        <img
                          src={`/images/coins/${c?.PrincipalCurrency?.toLowerCase()}.svg`}
                          alt={c?.PrincipalCurrency}
                          width={17}
                          height={17}
                        />
                        <p className="txtColor" style={{ margin: 0 }}>
                          {c?.PrincipalCurrency}
                        </p>
                      </div>
                      <div className="col-4">
                        <p className="txtColor">Earn:</p>
                      </div>
                      <div className="col-8">
                        <p className="txtColor">
                          {c?.EarnRate.toFixed(2)}% {c?.PayoutCurrency}
                        </p>
                      </div>

                      <div className="col-4">
                        <p className="txtColor">Min Amount:</p>
                      </div>
                      <div className="col-8">
                        <p className="txtColor">
                          {c?.MinAmount} {c?.PrincipalCurrency}
                        </p>
                      </div>
                      <div className="col-4">
                        <p className="txtColor">Max Amount:</p>
                      </div>
                      <div className="col-8">
                        <p className="txtColor">
                          {c?.MaxAmount} {c?.PrincipalCurrency}
                        </p>
                      </div>
                      <div className="col-4">
                        <p className="txtColor">Duration:</p>
                      </div>
                      <div className="col-8 d-flex gap-2">
                        <p className="txtColor">
                          {moment(c?.StartsOn).format("DD-MM-YYYY")}
                        </p>
                        <p>till</p>
                        <p className="txtColor">
                          {" "}
                          {moment(c?.EndsOn).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>
                    {isLoggedIn ? (
                      <button
                        className="joinBtn"
                        onClick={() => handleAddEarn(c)}
                      >
                        Join Campaign
                      </button>
                    ) : (
                      <Link to={"/login"} className="joinBtn">
                        Login to Join
                      </Link>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <h2>No Data</h2>
            )}
          </div>
        )}
      </div>
      <Footer />
      <EarnModal
        show={showModal}
        setShowModal={setShowModal}
        data={selectedCampaign}
      />
    </div>
  );
}

export default EarnCampaign;
